import React, { FC } from 'react';
import { UserType } from 'api/models';
import { useUser } from 'hooks/use-user';
import { useAccountSettingsMembersWsUpdates } from 'hooks/websockets';
import { PartnerTeamMemberSettingsPage } from './partner-team-members';
import { VendorMembersSettingsPage } from './vendor-team-members';

export const TeamMemberSettingsPage: FC = () => {
  const {
    user: { userType },
  } = useUser();

  useAccountSettingsMembersWsUpdates();

  return userType === UserType.Partner ? (
    <PartnerTeamMemberSettingsPage />
  ) : (
    <VendorMembersSettingsPage />
  );
};
